<template>
    <div>
        <div v-if="this.details.experience">
            <i class="fas fa-check text-green-700"></i> 
            <a href="javascript:void(0)" @click="show=true" class="link text-green-600 hover:text-green-800 hover:no-underline text-base line-through">
                Provide Experience Detail
            </a>
        </div>
        <div v-else>
            <a href="javascript:void(0)" @click="show=true" class="pl-4 link link-gray text-base">
                Provide Experience Detail
            </a>
        </div>
        <div v-if="show" class="pl-4 pt-4">
            <div>
               <div class="flex justify-start">
                   <div class="mt-2 pr-4">
                       <label class="align-baseline">Years of Home Health Coding Experience:</label>
                   </div>
                   <input type="number" v-model="years" class="form-control input w-1/5">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['details', 'emrs'],
        data() {
            return {
                profile: this.details,
                show: false,
                years: '',
                emrList: this.emrs,
                // resolution: '',
            }
        }, 
        // computed: {
        //     lastProblem: function() {
        //         return this.problems.slice(-1)[0];
        //     }
        // },
        methods: {
            // addComment() {
            //     this.patch('/problems/'+this.lastProblem.id, {'resolved_comment': this.resolution})
            //         .then(({data}) => {
            //             this.data.slice(-1)[0] = data;
            //         })
            // }
        }
    }
</script>